const api3RD = {
    // === Sport ===
    ibc2Sport: 'ibc2Sport_balance',
    ibc2Transfer: 'ibc2Sport_transfer',
    ibc2Login: 'ibc2Login_login',

    cmdSport: 'cmdSport_balance',
    cmdSportDeposit: 'cmdSport_deposit',
    cmdSportWithdraw: 'cmdSport_withdraw',
    cmdSportLogin: 'cmdSport_getLobbyLink',

    btiSport: 'BTiGameBean_checkBalance',
    btiSportDeposit: 'BTiGameBean_deposit',
    btiSportWithdraw: 'BTiGameBean_withdraw',
    btiSportLogin: 'BTiLoginBean_login',

    // === Live Casino ===
    pragmaticBalance: 'getGame3rdBalance',
    pragmaticTransfer: 'game3rdTransfer',
    pragmaticLogin: 'launchGame3rd',

    evolutionBalance: 'getGame3rdBalance',
    evolutionTransfer: 'game3rdTransfer',
    evolutionLogin: 'launchGame3rd',

    dgBalance: 'getGame3rdBalance',
    dgTransfer: 'game3rdTransfer',
    dgLogin: 'launchGame3rd',

    agBalance: 'agCasino_balance',
    agDeposit: 'agCasino_deposit',
    agWithdraw: 'agCasino_withdraw',
    agLogin: 'agCasino_goLobby',

    sgBalance: 'sgCasino_balance',
    sgDeposit: 'sgCasino_deposit',
    sgWithdraw: 'sgCasino_withdraw',
    sgLogin: 'sgLogin_login',

    saBalance: 'saCasino_balance',
    saDeposit: 'saCasino_deposit',
    saWithdraw: 'saCasino_withdraw',
    saLogin: 'saLogin_login',

    wmBalance: 'wmCasino_balance',
    wmTransfer: 'wmCasino_transfer',
    wmLogin: 'wmLogin_login',

    v8Balance: 'V8GamesBean_v8CheckBalance',
    v8Deposit: 'V8GamesBean_v8Deposit',
    v8Withdraw: 'V8GamesBean_v8Withdraw',
    v8Login: 'V8LoginBean_v8login',

    // === Slot Games ===
    habaBalance: 'habaSlot_balance',
    habaDeposit: 'habaSlot_deposit',
    habaWithdraw: 'habaSlot_withdraw',
    habaLogin: 'habaSlot_list',

    dsBalance: 'DSGameBean_DSCheckBalance',
    dsDeposit: 'DSGameBean_DSDeposit',
    dsWithdraw: 'DSGameBean_DSWithdraw',
    dsLogin: 'loginEntry3rdGame',
    dsSLot: 'DSGameLoginBean_DSLogin',

    DSGameBean: "DSGameBean_DSGetOceanLord",

    // === JILI (dùng chung khung generic như PRAG/EVO/DG — đã xác nhận trên staging) ===
    // balance: getGame3rdBalance {gameId:'JILI'} | transfer: game3rdTransfer
    // vào section: loginEntry3rdGame {sname:'Slots', svalue:'jili_slot'} → {code:0}
    // mở game: launchGame3rd {gameId:'JILI', code:<mã game>} → {listUrl:[url]}
    jiliBalance: 'getGame3rdBalance',
    jiliTransfer: 'game3rdTransfer',
    jiliLogin: 'launchGame3rd',

    // === PG Soft (khung generic giống JILI; quy đổi 1:1 VND) ===
    // balance: getGame3rdBalance {gameId:'PGSOFT'} | transfer: game3rdTransfer
    // vào section: loginEntry3rdGame {sname:'Slots', svalue:'jili_slot'} → {code:0}
    // mở game: launchGame3rd {gameId:'PGSOFT', code:<mã game>} → {html:'<...>'} (KHÔNG phải link)
    pgsBalance: 'getGame3rdBalance',
    pgsTransfer: 'game3rdTransfer',
    pgsLogin: 'launchGame3rd',

    // === Playtech (PT) — khung generic giống PG Soft; quy đổi 1:1 VND ===
    // list: pt_list {category:'slot'|'live'} | balance: getGame3rdBalance {gameId:'PT'} | transfer: game3rdTransfer
    // vào section: loginEntry3rdGame {sname:'Slots', svalue:'pt_slot'} → {code:0}
    // mở game: launchGame3rd {gameId:'PT', code:<gameCode>, category:'slot'|'live'} → {listUrl:[<link ptlaunch.cgi, hiệu lực 2 phút>]}, mở link ở tab mới
    ptBalance: 'getGame3rdBalance',
    ptTransfer: 'game3rdTransfer',
    ptLogin: 'launchGame3rd',
};

export default api3RD;
